exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3O0OM div[data-hook=player-container]>div{overflow:hidden}._3O0OM div[data-hook=screen-block]>video{position:absolute;top:50%;left:50%;min-width:100%;min-height:100%;width:100%;height:auto!important;transform:translateX(-50%) translateY(-50%)}", ""]);

// exports
exports.locals = {
	"player-container": "_3O0OM",
	"playerContainer": "_3O0OM"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader??ref--2-2!./node_modules/stylus-loader??ref--2-3!./src/widget/containers/channel-cover/video-preview/video-preview.styl
// module id = 1468
// module chunks = mobile/mobile mobile-overlay/mobile-overlay full-screen-modals/full-screen-modals widget/strip widget/classic widget/compact